import React from "react";

const CentralLock = () => {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="5.81262" cy="11.922" r="0.857937" stroke="#252525" stroke-width="0.7"/>
        <path d="M5.8125 12.8125V14.0823" stroke="#252525" stroke-width="0.5" stroke-linecap="round"/>
        <rect x="5.8125" y="3.79688" width="11.4286" height="2.79365" rx="1.39683" stroke="#252525"/>
        <path d="M8.34896 2.65079L7.0859 1.8689C6.22589 1.33651 5.1387 1.33651 4.27868 1.8689V1.8689C3.49345 2.355 3.01562 3.21277 3.01562 4.13628V13.3676C3.01562 14.1442 3.34419 14.8846 3.92009 15.4056V15.4056C4.93198 16.3212 6.46237 16.3556 7.51443 15.4865L7.57302 15.4381C8.22526 14.8993 8.60293 14.0974 8.60293 13.2514V7.98413" stroke="#252525" stroke-linecap="round"/>
        </svg>        
    );
}
export default CentralLock
